import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_DOCUMENT_TYPES = 'requestDocumentTypes';

export function requestDocumentTypes(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_DOCUMENT_TYPES;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => {
            const policyTypeCode = action.payload.policyTypeCode
                ? action.payload.policyTypeCode
                : '___';
            const claimCategoryCode = action.payload.claimCategoryCode
                ? action.payload.claimCategoryCode
                : '___';
            const formTypeCode = action.payload.formTypeCode
                ? action.payload.formTypeCode
                : '___';

            return {
                url:
                    GENERAL_FUNCTIONS.getBaseURL() +
                    `api/DocumentType/PolicyTypeCode/${policyTypeCode}/ClaimCategoryCode/${claimCategoryCode}/FormTypeCode/${formTypeCode}`,
                headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
                category: REQUEST_DOCUMENT_TYPES,
                method: 'GET',
            };
        });

    let httpResponse$ = sources.HTTP.select(REQUEST_DOCUMENT_TYPES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchDocumentTypesSuccess(response)
                : actions.fetchDocumentTypesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
